import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const FilterViewsSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="rounded" width={150} height={32} />
    <Skeleton variant="circular" width={32} height={32} />
  </Styles.Container>
)

export default FilterViewsSkeleton
